module.exports = __webpack_public_path__ + "static/media/logo.b58ef9fc.png";